import { render, staticRenderFns } from "./SpecializationInfoTalentFindNurse.vue?vue&type=template&id=45670c7d&scoped=true"
import script from "./SpecializationInfoTalentFindNurse.vue?vue&type=script&lang=js"
export * from "./SpecializationInfoTalentFindNurse.vue?vue&type=script&lang=js"
import style0 from "./SpecializationInfoTalentFindNurse.vue?vue&type=style&index=0&id=45670c7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45670c7d",
  null
  
)

export default component.exports